import React from 'react';
import styled from 'styled-components';
import Header from './header';
import Footer from './footer';
import { bannerBackground, doctor02 } from '../../constants/images';

interface AuthPageProps {
    children: React.ReactNode;
}

const PageContainer = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    min-height: 100vh;
    background: url(${bannerBackground}),linear-gradient(rgba(255, 255, 255, 0.773), #d5e7fe) no-repeat center center;
    background-size: auto;
`;

const Content = styled.main`
    flex: 1;
    display: flex;
    position: relative;
    justify-content: flex-start;
    align-items: center;
    width:  100%;
    /* margin-top: 70px; */
    min-height: 70vh;
    flex-direction: column;
    margin-bottom: 20px;
`;

const AuthPage: React.FC<AuthPageProps> = ({ children }) => {
    return (
        <PageContainer>
            <Header />
            <Content className='main-wrapper home-one'>
                {children}
            </Content>
            <Footer />
        </PageContainer>
    );
};

export default AuthPage;